import { gql } from '@apollo/client'

export const PERMISSIONS_FRAGMENT = gql`
  fragment PERMISSIONS on SecurityProfilePermissions {
    home
    planRegister
    createPlan
    kpiRegister
    createKPI
    actionRegister
    createAction
    objectiveRegister
    globalSearch
    reporting
    manageReports
    settings
    planModifyPlan
    planDeletePlan
    planCreateScheduledReview
    planModifyScheduledReview
    planDeleteScheduledReview
    planViewInProgressReview
    planViewCompletedReview
    planLinkObjects
    planAddItemsFromParentPlan
    planAddObjective
    planAddKPI
    planAddAction
    planSetPlanSecurity
    planSetUserPlanSecurity
    planCreateSubPlan
    objectiveModifyObjective
    objectiveDeleteObjective
    objectiveArchiveObjective
    objectiveCreateScheduledReview
    objectiveModifyScheduledReview
    objectiveDeleteScheduledReview
    objectiveViewInProgressReview
    objectiveViewCompletedReview
    objectiveLinkObjects
    objectiveCreateResource
    objectiveModifyResource
    objectiveDeleteResource
    objectiveAddObjective
    objectiveAddAction
    objectiveAddKPI
    objectiveSetUserObjectiveSecurity
    actionModifyAction
    actionDeleteAction
    actionArchiveAction
    actionCreateScheduledReview
    actionModifyScheduledReview
    actionDeleteScheduledReview
    actionViewInProgressReview
    actionViewCompletedReview
    actionLinkObjects
    actionCreateResource
    actionModifyResource
    actionDeleteResource
    actionAddObjective
    actionAddAction
    actionAddKPI
    actionSetUserActionSecurity
    kpiModifyKPI
    kpiDeleteKPI
    kpiArchiveKPI
    kpiCreateScheduledReview
    kpiModifyScheduledReview
    kpiDeleteScheduledReview
    kpiViewInProgressReview
    kpiViewCompletedReview
    kpiLinkObjects
    kpiAddKPIResult
    kpiModifyKPIResult
    kpiDeleteKPIResult
    kpiAddObjective
    kpiAddAction
    kpiAddKPI
    kpiModifyUserKPISecurity
    adminViewPrivatePlans
    adminViewPrivateRisks
    adminLockPlans
    reportingCreate
    reportingEdit
    reportingDelete
    reportingClone
    reportingRefresh
    riskCreate
    riskDelete
    riskModify
    riskSetSecurity
    riskSetUserRiskSecurity
    riskViewRelatedRisks
    manageRiskTemplates
    manageDisabledRisks
    manageDashboards
    scheduleRisks
    editReadOnlyFields
    modifyOwnedGroupedRisks
    viewLinkedParentRisk
    riskArchive
    viewOrganizationLevelData
    aiViewUsage
    aiManageSettings
    aiEnableUsage
  }
`

export const SECURITY_PROFILES_QUERY = gql`
  query SECURITY_PROFILES_QUERY($filter: SecurityProfileFilterInput, $order: OrderInput, $pagination: PaginationInput) {
    securityProfiles(filter: $filter, order: $order, pagination: $pagination) {
      data {
        id
        createdAt
        updatedAt
        companyId
        name
        permissions {
          ...PERMISSIONS
        }
        active
      }
      pagination {
        pageSkip
        pageTake
        totalCount
      }
    }
  }
  ${PERMISSIONS_FRAGMENT}
`

export const SECURITY_PROFILES_SELECT_QUERY = gql`
  query SECURITY_PROFILES_SELECT_QUERY($filter: SecurityProfileFilterInput) {
    securityProfiles(filter: $filter) {
      data {
        id
        name
        active
      }
    }
  }
`
